import { Collapse, CollapseProps, Flex } from 'antd';
import { FC, Fragment, ReactNode } from 'react';
import { StagesStore } from '../../../../DataSource/Stores/Cabinet/StagesStore';
import { WorkspacesStore } from '../../../../DataSource/Stores/Cabinet/WorkspacesStore';
import * as styles from './index.module.scss';

interface IProps {
  expandIcon: (panelProps: any) => ReactNode;
  assignedTo?: string;
}

const MemberTasksBlock: FC<IProps> = ({ expandIcon, assignedTo }) => {
  const memberTasksCollapseItems: CollapseProps['items'] = [
    {
      key: '1',
      label: 'ЗАДАЧИ ПОЛЬЗОВАТЕЛЕЙ',
      children: (
        <Flex vertical gap={8}>
          {StagesStore.dataUserTask.map((task) => (
            <Fragment key={task._id}>
              <div className={styles.field}>
                <p className={styles.label}>{task.title}</p>
                {task.status}
              </div>

              <div className={styles.field}>
                <p className={styles.label}>Ответственный</p>
                {task.assignedTo && assignedTo
                  ? WorkspacesStore.members[assignedTo]?.userId?.firstname
                  : 'Ответственный'}
              </div>
            </Fragment>
          ))}
        </Flex>
      ),
    },
  ];

  return (
    <Collapse
      items={memberTasksCollapseItems}
      expandIcon={expandIcon}
      expandIconPosition="right"
      bordered={false}
      defaultActiveKey={[1]}
      ghost
    />
  );
};

export default MemberTasksBlock;
